import { VisualizerProject } from "@app/shared";
import cn from "classnames";
import { emptyGuid } from "../../../../helpers";
import { CheckboxInput, InputRow, NumericInput } from "../../../shared";
import { ProjectWithData } from "../ProjectWithData";

type EditVideoSettingsProps = {
    project: Partial<VisualizerProject>;
    setProject: React.Dispatch<React.SetStateAction<Partial<ProjectWithData>>>;
    maxHeight?: number;
};

export const EditVideoSettings: React.FC<EditVideoSettingsProps> = ({ project, setProject, ...props }) => {
    if ((project.id + "") === emptyGuid) {
        return <div>Invalid Project ID !</div>
    }
    return (
        <div className={cn(props.maxHeight ? `max-h-[${props.maxHeight}px]` : "", "overflow-y-auto")}>
            <InputRow>
                <CheckboxInput label="Use Intrinsic Translation" checked={project.useIntrinsicTranslation} onChange={(e) => setProject((old) => ({ ...old, useIntrinsicTranslation: e.target.checked }))} />
            </InputRow>
            <InputRow>
                <NumericInput label="Estimated Return Height" value={project.estimatedReturnHeight} onChange={(val) => setProject((old) => ({ ...old, estimatedReturnHeight: val }))} />
            </InputRow>
        </div>
    );
}